import { entityStatusSideMsgValue } from '#/modules/commonComponents/table/entityStatusIconHelpers';

function dash(value) {
  if (value === null || value === undefined || value === '') {
    return '-';
  }
  return value;
}

/** Block A：僅狀態 */
export const customerSideMsgStatusBlock = {
  fields: [
    {
      key: 'status',
      label: '狀態',
      render: (row) => (
        <div className="side_msg-row">
          <h3>狀態</h3>
          {entityStatusSideMsgValue(row)}
        </div>
      ),
    },
  ],
};

/** Block C：主檔摘要 */
export const customerSideMsgDetailBlock = {
  fields: [
    { label: '代號', value: 'code' },
    { label: '名稱', value: 'name' },
    { label: '中文名', value: (row) => dash(row?.chineseName) },
    { label: '統編', value: (row) => dash(row?.taxIdNumber) },
    { label: '電話', value: (row) => dash(row?.phone) },
    { label: '備註', value: (row) => dash(row?.remark) },
  ],
};
